import { forwardRef, useImperativeHandle, useState } from "react"
import Chips from "../../../../../../library/Chips/Chips"
import clearBtn from "../../../../../../assets/chips/chip_delete.png"
import { changeAmountToFixed } from "../../../../Utillitys/changeAmountToFixed"

const AndarBaharClassicChipsController = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({

    }))

    const changeChip = (value, index) => {
        if (index !== props.selectedBetChip) {
            props.setSelectedBetChip(index)
        }
    }

    return (<div id="chipsController">
        <div id="coinContainer">
            <button id="clearBtn" onClick={props.clearAllBets}><img id="clearBtnImg" src={clearBtn}></img></button>
            <Chips chipHeight="100%" chipWidth="100%" gameChips={props.abt_chipValues} selectedChipIndex={props.selectedBetChip} chipSelectionFn={changeChip} isMobile={true}></Chips>
        </div>
        <div id="betButtons">
            <div className="btnChild">
                <p>{props.language.TotalBet}</p>
                <p>{changeAmountToFixed(props.betAmount, 2)}</p>
            </div>
            <div className="ABC_NT_Btn_Div" onClick={() => { !(props.betBtn === props.language.Prev || props.isBetSent || !Boolean(Number(props.betAmount))) && props.doubleFn() }}><button className="btnChild" disabled={props.betBtn === props.language.Prev || props.isBetSent || !Boolean(Number(props.betAmount)) || props.disableBetBtn}>{props.language.Double}</button></div>
            <div className="ABC_NT_Btn_Div" onClick={() => { !((!Boolean(Number(props.betAmount)) && props.language.BetOK === props.betBtn) || props.isBetSent) && props.betFn(props.betBtn) }}><button className={`btnChild${props.betBtn === props.language.BetOK ? " betOkBtnActive" : ""}`} disabled={(!Boolean(Number(props.betAmount)) && props.language.BetOK === props.betBtn) || props.isBetSent || props.disableBetBtn}>{props.betBtn}</button></div>
        </div>
    </div>)
})

export default AndarBaharClassicChipsController